module.exports = __webpack_public_path__ + "img/symbol_7.7936a662.png";